/* External */
import { all, fork, put, race, select, take, takeLatest } from "redux-saga/effects";

/* Actions */
import { pdpDataSuccess } from "./actions";
import { actionTypes as assetActionTypes, fetchPdpAsset } from "./asset/actions";
import { actionTypes as continueWatchingActionTypes, fetchPdpContinueWatching } from "./continueWatching/actions";
import { actionTypes as seasonsActionTypes, fetchPdpSeason } from "./seasons/actions";
import { actionTypes as heartbeatActionTypes } from "../player/heartbeat/actions";
import { actionTypes as streamsHistoryActionTypes, fetchStreamsHistory } from "../streamsHistory/actions";
import { actionTypes } from "./actions";

/* Sagas */
import asset from "./asset/sagas";
import continueWatching from "./continueWatching/sagas";
import seasons from "./seasons/sagas";

/* Others */
import { PDP_ASSET_TYPES, STATUS_TYPES } from "../../utils";

function* pdp({ payload }) {
  const { assetType } = payload;
  const assetStatus = yield select((state) => state.pdp.asset.status);
  const heartbeatStatus = yield select((state) => state.player.heartbeat.status);
  const seasonsStatus = yield select((state) => state.pdp.seasons.status);

  if (STATUS_TYPES.UNLOAD_STATE === assetStatus) {
    yield put(fetchPdpAsset(payload));
    yield take(assetActionTypes.SUCCESS);
  }

  // Ensure continue watching and streams history calls take the updated progress
  if (heartbeatStatus !== STATUS_TYPES.UNLOAD_STATE) yield take(heartbeatActionTypes.RESET);

  if ([PDP_ASSET_TYPES.series, PDP_ASSET_TYPES.movies].includes(assetType)) {
    yield put(fetchPdpContinueWatching(payload));
    yield race([take(continueWatchingActionTypes.SUCCESS), take(continueWatchingActionTypes.FAILURE)]);
  }

  if (assetType !== PDP_ASSET_TYPES.movies && assetType !== PDP_ASSET_TYPES.live) {
    yield put(fetchStreamsHistory());
    yield race([take(streamsHistoryActionTypes.SUCCESS, streamsHistoryActionTypes.FAILURE)]);
  }

  if (assetType === PDP_ASSET_TYPES.series && STATUS_TYPES.UNLOAD_STATE === seasonsStatus) {
    const { episodeId } = payload;
    const seasons = yield select((state) => state.pdp.asset.data?.seasonsList);
    const continueWatchingData = yield select((state) => state.pdp.continueWatching.data);
    let findSeason, seasonId;

    if (episodeId) {
      findSeason = ({ episodeIDs }) => episodeIDs.some((episode) => episode === episodeId);
    } else if (continueWatchingData) {
      findSeason = (season) => continueWatchingData.season === season.seasonNumber;
    }

    seasonId = findSeason ? seasons?.find(findSeason)?.id : seasons?.[0]?.id;

    if (!seasonId) return;

    yield put(fetchPdpSeason({ seasonId }));
    yield take(seasonsActionTypes.SUCCESS);
  }

  yield put(pdpDataSuccess());
}

export default function* () {
  yield all([fork(asset), fork(continueWatching), fork(seasons), takeLatest(actionTypes.FETCH, pdp)]);
}
